/** A byte count an operator can read at a glance. */
export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${String(bytes)} B`;
  const units = ["KB", "MB", "GB", "TB"];
  let value = bytes / 1024;
  let unit = 0;
  while (value >= 1024 && unit < units.length - 1) {
    value /= 1024;
    unit += 1;
  }
  return `${value.toFixed(value < 10 ? 1 : 0)} ${units[unit] ?? ""}`;
}

/**
 * "25 of 412", or "12" when 12 is all there is.
 *
 * Every table in the console that is fed by a capped query says this under
 * itself. A page exactly as long as the limit is otherwise indistinguishable
 * from a complete answer, which on a common domain is the difference between
 * "these are the affected sites" and "these are the first 25 of them"
 * (LGN-125, audit M13).
 */
export function formatCount(shown: number, total: number, noun: string): string {
  const suffix = total === 1 ? noun : `${noun}s`;
  return total > shown
    ? `Showing ${shown.toLocaleString()} of ${total.toLocaleString()} ${suffix}`
    : `${total.toLocaleString()} ${suffix}`;
}
